import React, { ComponentProps, FC } from 'react';

import { PlayerView as BasePlayerView } from '@/scenarios/legacy-player/components/PlayerView/PlayerView';

export const PlayerView: FC<ComponentProps<typeof BasePlayerView>> = (props) => (
    <BasePlayerView {...props} />
);
